<template>
    <section class="simditor-wrapper">
        <textarea id="editor" ref="editorHolder" autofocus maxlength="5000"></textarea>
    </section>
</template>
<script type="text/javascript">
    import Simditor from 'simditor'
    import 'simditor/styles/simditor.css'

    export default {
        name: 'VueEditor',
        props: {
            value: String,
            placeholder: {
                type: String,
                'default': '请输入...'
            },
            options: {
                type: Object,
                'default' () {
                    return {
                        toolbarFloat: false,
                        cleanPaste: true
                    }
                }
            },
            insertContent: {
                type: String,
                'default': ''
            }
        },
        data () {
            return {
                editor: null,
                lastRange: '', // 最近失去焦点的位置
                status: ''
            }
        },
        watch: {
            insertContent (newValue) {}
        },
        methods: {
            initVueditor () {
                this.setEditor()
                this.setEditorListener()
            },
            resetContent (content) {
                this.editor.setValue(content)
                this.$emit('input', this.editor.getValue().replace(/font-size: 1px;/ig, ''))
            },
            addAfterCursor (html) {
                let CaretPos = 0,
                    ctrl = this.editor.body[0]
                if (this.lastRange && this.value !== '') {
                    if (window.Selection) {
                        let sel = window.getSelection()
                        let range = this.lastRange
                        let el = document.createElement('span')
                        el.innerHTML = html
                        let frag = document.createDocumentFragment(), node, lastNode
                        while ((node = el.firstChild)) {
                            lastNode = frag.appendChild(node)
                        }
                        range.insertNode(frag)
                        if (lastNode) {
                            range = range.cloneRange()
                            range.setStartAfter(lastNode)
                            range.collapse(true)
                            sel.removeAllRanges()
                            sel.addRange(range)
                        }
                        this.lastRange = range
                    } else if (document.selection && document.selection.type !== 'Control') {
                        this.lastRange.pasteHTML(html)
                    }
                } else {
                    this.editor.setValue(this.value + html)
                    this.editor.focus()
                }
                this.$emit('input', this.editor.sync().replace(/font-size: 1px;/ig, ''))
            },
            getCursorHandler () {
                let CaretPos = 0,
                    ctrl = this.editor.body[0]
                if (window.Selection) {
                    let sel = window.getSelection()
                    if (sel.getRangeAt && sel.rangeCount) {
                        let range = sel.getRangeAt(0)
                        range.deleteContents()
                        return range
                    }
                } else if (document.selection && document.selection.type !== 'Control') {
                    return document.selection.createRange()
                }
                return null
            },
            setEditor () {
                this.editor = new Simditor(Object.assign({
                    textarea: this.$refs.editorHolder,
                    placeholder: this.placeholder,
                    toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', 'color', 'ol', 'ul', 'indent', 'outdent', 'alignment']
                }, this.options))
                // 初始值
                this.editor.setValue(this.value)
            },
            setEditorListener () {
                // 失去焦点，打个标记
                this.editor.on('blur', () => {
                    this.status = 'blur'
                    this.lastRange = this.getCursorHandler()
                })
                // 内容变化
                this.editor.on('valuechanged', (e, src) => {
                    this.status = 'valuechanged'
                    const val = this.editor.getValue()
                    this.$emit('input', val ? val.replace(/font-size: 1px;/ig, '') : val)
                })
            }
        },

        mounted () {
            this.initVueditor()
        },

        destroy () {
            this.editor.destroy()
            this.editor = null
        }
    }
</script>
<style type="text/css" lang="scss">
    // 自定义样式或者兼容
    .simditor-wrapper {
        .simditor {
            .simditor-body {
                padding    : 10px;
                min-height : 150px;
                max-height : 300px;
                overflow   : auto;
                /*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
                &::-webkit-scrollbar{
                    width: 10px;
                    height: 10px;
                    background-color: #eee;
                }
                /*定义滚动条的轨道，内阴影及圆角*/
                &::-webkit-scrollbar-track{
                    background-color: #eee;
                }
                /*定义滑块，内阴影及圆角*/
                &::-webkit-scrollbar-thumb{
                    /*width: 10px;*/
                    height: 10px;
                    background-color: #ddd;
                }
                p, div {
                    margin-bottom : 5px;
                }
                ol {
                    list-style-type : decimal;
                }
                ul {
                    list-style-type : disc;
                }
                li {
                    list-style : inherit;
                }
            }
            .simditor-wrapper .simditor-placeholder {
                padding : 10px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// main.vue?c2d5b6b6